import React from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {toCamelCase} from '../../../../functions/camelSnakeCaseConversion';
import {toKebabForDataCy} from '../../../../functions/toKebabForDataCy';
import LinkIcon from '../../../../assets/icons/LinkIcon';
import * as css from './WhatsAppButtonRow.css';

interface WhatsAppButtonRowProps {
    buttons?: Array<{value: string}>;
}

function WhatsAppButtonRow({buttons = []}: WhatsAppButtonRowProps) {
    const {t} = useTranslation('variables');
    const currentLang = useSelector((s: any) => s.branding?.currentLang || 'he');

    if(!buttons || buttons.length === 0) {
        return null;
    }

    return (
        <>
            {buttons.map((button, index) => (
                <css.button key={button?.value || index} data-cy={`whatsapp-template-action-btn-${toKebabForDataCy(button?.value) || `item-${index}`}`}>
                    {t(toCamelCase((button.value).replace(/[[\]]/g, '')), {lng: currentLang})}
                    <LinkIcon />
                </css.button>
            ))}
        </>
    );
}

export default WhatsAppButtonRow;
